var map = {
	"./icon-flag-de.svg": 7025,
	"./icon-flag-dk.svg": 7791,
	"./icon-flag-no.svg": 158,
	"./icon-flag-se.svg": 8740,
	"./icon-flag-uk.svg": 4395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4861;